import React from 'react'
import CurrencyExchangeInput from '../form/CurrencyExchangeInput'

type Props = {
    value: number
    onChange?: (value: number) => void
}

const CurrencyExchangeRateInput: React.FC<Props> = (props) => {
    return (
        <>
            <span className="form-label">Курс валюты</span>
            <CurrencyExchangeInput
                value={props.value}
                onChange={props.onChange}
                className=" form-input bg-[#181818]"
            />
        </>
    )
}

export default CurrencyExchangeRateInput
